<template>
    <div class="setting-content--section" style="padding: 0;">
        <div style="padding: 1rem;">
            
        </div>
        <div style="text-align: center; font-size: 40px; font-family: DINNextLTPro-Medium, sans-serif;">
            <span style="display:block; font-size: 18px; opacity: 0.6;">{{ $gettext('Wait to be redirected.') }}</span>
            <LoadingSpinner :displayText="spinnerText" />
        </div>
    </div>
</template>
<script>
import BillingSettingService from "@/store/services/billingsetting.service";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";
export default {
    name: "GiveFreeMonth",
    components: { LoadingSpinner },
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Receive Free Month"),
                showCompanyPicker: false
            },
            spinnerText: this.$gettext('Wait to be redirected.'),
        }
    },
    created(){
        BillingSettingService.giveFreeMonth().then((response)=>{
            var promo_applied = response.data;
            if(promo_applied){
                window.location.href = window.Urls['gekkoDashboard']() + '?premium_congrats=yes';
            } else {
                window.location.href = window.Urls['gekkoDashboard']();
            }
            
        })
    }
}
</script>
<style></style>